import React from "react";
import ReactLoading from "react-loading";

/**
 * ConversationsPanel — Sidebar mesaj/konuşma sekmesi
 * NavbarMenu'dan çıkartıldı.
 */
const ConversationsPanel = ({
  conversations,
  isLoading,
  unreadMessageCount,
  onConversationClick,
  formatTime,
}) => {
  if (isLoading) {
    return (
      <div className="p-3" style={{ textAlign: "-webkit-center" }}>
        <ReactLoading type="spin" width="24px" height="24px" color="#268bd2" />
        <p className="mt-2">Yükleniyor...</p>
      </div>
    );
  }

  if (conversations.length === 0) {
    return (
      <div className="text-center p-3">
        <i className="icon-bubble" style={{ fontSize: "xx-large", color: "#ccc" }}></i>
        <p className="mt-2" style={{ color: "#999" }}>Henüz konuşma yok</p>
      </div>
    );
  }

  return (
    <ul className="list-unstyled" style={{ maxHeight: "400px", overflowY: "auto", margin: 0, padding: 0 }}>
      {conversations.map((conversation) => (
        <li
          key={conversation.id}
          onClick={() => onConversationClick(conversation.id)}
          style={{
            padding: "10px 15px",
            borderBottom: "1px solid #e0e0e0",
            cursor: "pointer",
            backgroundColor: conversation.unread_count > 0 ? "#f0f8ff" : "#f9f9f9",
            transition: "background-color 0.2s ease",
            width: "100%",
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#e8f4f8"; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = conversation.unread_count > 0 ? "#f0f8ff" : "#f9f9f9"; }}
        >
          <div className="media" style={{ display: "flex", alignItems: "flex-start" }}>
            <div className="media-body" style={{ flex: 1 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div style={{ flex: 1 }}>
                  <h6 style={{ margin: 0, fontWeight: conversation.unread_count > 0 ? "bold" : "normal" }}>
                    {conversation.customer?.name || "Müşteri"}
                  </h6>
                  <p style={{
                    margin: "5px 0 0 0", fontSize: "12px", color: "#666",
                    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                  }}>
                    {conversation.last_message?.message || "Mesaj yok"}
                  </p>
                </div>
                <div style={{ marginLeft: "10px", textAlign: "right" }}>
                  {conversation.unread_count > 0 && (
                    <span className="badge badge-danger" style={{ display: "inline-block", marginBottom: "5px" }}>
                      {conversation.unread_count}
                    </span>
                  )}
                  <small style={{ display: "block", fontSize: "11px", color: "#999" }}>
                    {formatTime(conversation.last_message?.created_at || conversation.updated_at)}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default ConversationsPanel;
